(function () {
    'use strict';

    angular
        .module('app.floorPlans')
        .factory('bookingInProgressDialog.dialog', bookingInProgressDialog);

    bookingInProgressDialog.$inject = ['$uibModal', 'opsIncludeVersion'];
    /* @ngInject */
    function bookingInProgressDialog($uibModal, opsIncludeVersion) {
        var service = {
            display: display
        }
        
        return service;

        function display(gmtDateAndRoom) {
            var modalOptions = {
                templateUrl: 'app/dialogs/_bookingInProgress.html?v=' + opsIncludeVersion,
                controller: BookingInProgressModalInstance,
                controllerAs: 'vm',
                keyboard: true,
                size: 'lg',
                resolve: {
                    options: function () {
                        return {
                            filters: gmtDateAndRoom
                        };
                    }
                }
            };

            return $uibModal.open(modalOptions).result;
        }
    }


    BookingInProgressModalInstance.$inject = ['$uibModalInstance', 'options', 'common', 'dataservice', 'servicesService'];

        /* @ngInject */
    function BookingInProgressModalInstance($uibModalInstance, options, common, dataservice, servicesService) {
        var vm = this;
        vm.items = [];
        vm.activeItems = [];
        vm.item = {};
        vm.servicesService = servicesService;
        vm.okText = 'Close';
        vm.ok = function () {
            $uibModalInstance.close('ok');
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
       
        activate();

        function activate() {
            var promises = [getData()];
            return common.$q.all(promises).then(function () {
            }, function (error) { });
        }


        function getData() {
            return dataservice.query("api/FloorPlans/GetBookedSpaceInRoomForDate", options.filters).then(function (response) {
                vm.items = response.data;
                var utcNow = moment.utc();
                for (var i = 0; i < vm.items.length; i++) {
                    var b = vm.items[i];
                    var start = moment.utc(b.GmtReservedStart);
                    var end = moment.utc(b.GmtReservedEnd);
                    if (utcNow.isBetween(start, end)) {
                        vm.item = b;
                        vm.activeItems.push(b);
                        break;
                    }
                }
                return vm.items;
            }, function (error) { });
        }

    }
})();
